import React from 'react';

/**
 * Placeholder that mirrors the magazine article card (ArticleCard):
 * cover image, title, teaser text and a meta footer.
 */
export default function ArticleCardSkeleton({ aspectClass = 'aspect-[16/10]' }) {
  return (
    <div className="flex flex-col h-full bg-white rounded-2xl overflow-hidden border border-gray-100">
      <div className={`relative ${aspectClass} overflow-hidden shimmer`} />
      <div className="flex flex-col flex-1 p-5">
        <div className="h-6 rounded shimmer w-3/4" />
        <div className="h-4 rounded shimmer w-full mt-3" />
        <div className="h-4 rounded shimmer w-5/6 mt-2" />
        <div className="flex items-center gap-3 mt-4">
          <div className="h-3.5 rounded shimmer w-24" />
          <div className="h-3.5 rounded shimmer w-14" />
        </div>
      </div>
    </div>
  );
}